import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowDown, ArrowLeft } from "lucide-react";
import ShreeDay from "../../Charts/ShreeJackpot/7PM";
import ShreeNight from "../../Charts/ShreeJackpot/8PM";
import MadhurDay from "../../Charts/ShreeJackpot/12PM";
import MadhurNight from "../../Charts/ShreeJackpot/1PM";
import MilanDay from "../../Charts/ShreeJackpot/3PM";
import MilanNight from "../../Charts/ShreeJackpot/4PM";
import RajdhaniDay from "../../Charts/ShreeJackpot/5PM";
import RajdhaniNight from "../../Charts/ShreeJackpot/6PM";
import Kalyan from "../../Charts/ShreeJackpot/10Am";
import KalyanNight from "../../Charts/ShreeJackpot/11Am";
import TimeBazar from "../../Charts/ShreeJackpot/9PM";
import MainBazar from "../../Charts/ShreeJackpot/2PM";
import AllJackpot from "../../Charts/ShreeJackpot/AllJackpot";
import { nameRejext } from "../../Helpers/StringRejex";
import { GetAllCharts } from "../../Helpers/GetCharts";
import Navbar from "../../Pages/Navbar/Navbar";
import Footer from "../../Pages/Footer/Footer";
import { GET_JACKPOT_JODI_CHART } from "../../service/admin.service";

const Andar_Bahar_Chart = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [getData, setgetData] = useState([]);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getResponseData = async () => {
    if (location.state.title !== "allratanjackpot") {
      const req = location.state;
      const res = await GetAllCharts(GET_JACKPOT_JODI_CHART, req);
      setgetData(res);
    }
  };

  useEffect(() => {
    getResponseData();
  }, []);

  const renderChart = () => {
    const chartMap = {
      "7:30PM": ShreeDay,
      "07:30PM": ShreeDay,
      "8:30PM": ShreeNight,
      "08:30PM": ShreeNight,
      "12:30PM": MadhurDay,
      "01:30PM": MadhurNight,
      "03:30PM": MilanDay,
      "04:30PM": MilanNight,
      "05:30PM": RajdhaniDay,
      "06:30PM": RajdhaniNight,
      "10:30Am": Kalyan,
      "11:30Am": KalyanNight,
      "9:30PM": TimeBazar,
      "09:30PM": TimeBazar,
      "02:30PM": MainBazar,
      allratanjackpot: AllJackpot,
    };

    const normalizedTitle = nameRejext(location.state.title);
    const ChartComponent = Object.entries(chartMap).find(
      ([key]) => nameRejext(key) === normalizedTitle,
    )?.[1];

    return ChartComponent ? <ChartComponent chartData={getData.data} /> : null;
  };

  const isAllJackpot = location.state.title === "allratanjackpot";
  const chartTitle = isAllJackpot ? "" : location.state.title;

  useEffect(() => {
    // scroll top fix
    window.scrollTo({ top: 0, behavior: "smooth" });
    getResponseData();
  }, []);

  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />

      <div className="tw-pt-8 tw-px-0 md:tw-px-8 lg:tw-px-16  tw-min-h-screen lg:tw-mt-20 tw-mt-12">
        <div className="tw-max-w-6xl tw-mx-auto">
          {/* Header */}
          <div className="tw-text-center tw-px-4 md:tw-px-8 tw-mb-8">
            <h1 className="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-gray-900 tw-mb-3">
              Jackpot {chartTitle} Pana Chart
            </h1>
            <p className="tw-text-gray-600 tw-text-xs md:tw-text-sm tw-max-w-3xl tw-mx-auto tw-mb-6">
              {chartTitle} Pana Chart lets you explore old records, result
              history, bracket details, live updates, and complete digit numbers
              with an easy and user-friendly experience.
            </p>
            <button
              onClick={handleClick}
              className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mx-auto tw-transition-colors"
            >
              Go To Bottom
              <ArrowDown className="tw-w-4 tw-h-4" />
            </button>
          </div>

          {/* Chart Container */}
          <div className="md:tw-bg-white  tw-shadow-sm tw-p-0 md:tw-p-6 tw-overflow-x-auto">
            <div className="tw-min-w-full">{renderChart()}</div>
          </div>

          {/* Back Button */}
          <div className="tw-flex tw-justify-center tw-mt-3 md:tw-mt-8">
            <button
              onClick={() => navigate(-1)}
              className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-transition-colors"
            >
              <ArrowLeft className="tw-w-4 tw-h-4" />
              Back
            </button>
          </div>
        </div>
      </div>

      <Footer variant="mini" />
      <div id="scroll-down"></div>
    </>
  );
};

export default Andar_Bahar_Chart;
